import { useAppConfig } from '@msrceng/auth';
import { useMemo } from 'react';
import { useQueries, } from '@tanstack/react-query';
import axios from 'axios';
import { FIVE_MINUTES_IN_MSEC } from '../../constants';
/**
 * API hook that fetches the status endpoints of a list of APIs, and returns a
 * list of `react-query` API hooks for reading all those APIs.
 *
 * See [useApiDownState](./useApiDownState.tsx) for an example of how to use this hook.
 */
export const useApiStatusStateApi = ({ apiList, pollingFrequency, }) => {
    var _a;
    const apiRoot = (_a = useAppConfig()) === null || _a === void 0 ? void 0 : _a.apiRoot;
    const pollingFrequencyInMsec = pollingFrequency * 60000;
    const options = useMemo(() => apiList.map(api => ({
        queryFn: () => axios
            .get(api)
            .then(d => d.status < 400 || d.status === 304)
            .catch(() => false),
        queryKey: ['status', api],
        refetchInterval: pollingFrequencyInMsec,
        cacheTime: pollingFrequencyInMsec,
        staleTime: pollingFrequencyInMsec,
        keepPreviousData: true,
        retryDelay: FIVE_MINUTES_IN_MSEC,
        enabled: !!apiRoot && (apiRoot === null || apiRoot === void 0 ? void 0 : apiRoot.length) > 0,
    })), [apiList, apiRoot, pollingFrequencyInMsec]);
    return useQueries({
        queries: options,
    });
};
